export default "__VITE_PUBLIC_ASSET__07fd8a46__"